











































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
import Response from "@/models/checkRequest/response";

@Component({
  computed: {
    ...mapGetters("subscriptions", ["hasActiveSubscription"]),
  },
})
export default class ResultsPane extends Vue {
  showHeaders = false;
  get showError(): boolean {
    return this.result.errorReasonPhrase ? true : false;
  }

  // mapState + mapGetters
  hasActiveSubscription!: boolean;

  @Prop()
  result!: Response;
}
